module.exports = __webpack_public_path__ + "static/media/激光切割气象站.7c6ba400.png";